function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 14a1 1 0 01-.48-.12l-11-6a1 1 0 010-1.76l11-6a1 1 0 01.96 0l11 6a1 1 0 010 1.76l-11 6A1 1 0 0112 14zM3.09 7L12 11.86 20.91 7 12 2.14 3.09 7z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 19a1 1 0 01-.44-.1l-11-5.34a1 1 0 01-.11-1.73l1-.66a1 1 0 011.44 1.3L12 16.88l9.11-4.43a1 1 0 01.9-1.46 1 1 0 01.54.16l1 .67a1 1 0 01-.11 1.73l-11 5.34-.44.1z"
});

var SvgIconMapLayers = function SvgIconMapLayers(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.41
  }, props), _ref, _ref2);
};

export default SvgIconMapLayers;